"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlParameter = void 0;
function getUrlParameter(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
}
exports.getUrlParameter = getUrlParameter;
